import { render, staticRenderFns } from "./teamDetails.vue?vue&type=template&id=8ac7d5d6&"
import script from "./teamDetails.vue?vue&type=script&lang=js&"
export * from "./teamDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports